<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import learningApiUser from '@src/services/api/learning/user'
import DefineValidation from '@services/validation/DefineValidation'
import { useLearningAuthStore } from '@stores/auth'
import Modal from '@components/modal/Modal.vue'

const { updateAccessToken } = useLearningAuthStore()

const router = useRouter()

const { errors, meta, handleSubmit, handleReset, models } = new DefineValidation((modules) => {
  return {
    email: modules.string().required().email().label('メールアドレス')
  }
})

const sendButtonDisabled = computed(() => {
  return !(meta.value.valid && meta.value.dirty)
})

const showCompleteModal = ref(false)

const toLogin = () => {
  showCompleteModal.value = false
  router.push({
    name: 'Login'
  })
}

const sendForm = handleSubmit(async (values) => {
  const body = {
    email: models.email.value
  }
  console.log('body', body)
  learningApiUser.sendAccountReminder(body).then((res) => {
    console.log('sendAccountReminder res', res)
    showCompleteModal.value = true
  }).catch((err) => {
    console.error('sendAccountReminder err', err)
  })
})
</script>

<template>
  <section>
    <div class="container">
      <h2>アカウント確認</h2>
      <p>ご登録のメールアドレスを入力し、確認メールを送信ボタンを押してください。<br><br></p>
      <form @submit.prevent="sendForm">
        <div class="c-compBox">
          <div class="p-form-field">
            <label
              for="email"
              class="c-input-label"
            ><span class="c-form-required">必須</span>メールアドレス</label>
            <input
              id="email"
              v-model="models.email.value"
              type="text"
              class="c-input-text"
              placeholder="email@example.com"
              autocomplete="off"
              maxlength="256"
            >
            <div class="c-validationError u-text-center">
              {{ errors.email }}
            </div>
          </div>
          <div class="authEmailSend__send">
            <button
              type="submit"
              class="c-button c-button--medium c-button--yellow"
            >
              確認メールを送信
            </button>
            <RouterLink
              :to="{name:'Login'}"
              class="c-button c-button--medium c-button--border"
            >
              戻る
            </RouterLink>
          </div>
        </div>
      </form>
    </div>

    <Modal :show="showCompleteModal">
      <template #body>
        <div class="l-modal__body">
          <h2 class="l-modal__ttl">
            メールを送信しました。<br>メールにあるアカウントをご確認ください。
          </h2>
          <div class="l-modal__buttons">
            <button
              class="c-modalBtn c-modalBtn--single c-modalBtn--gray"
              type="button"
              @click="toLogin"
            >
              ログイン画面に戻る
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<style scoped lang="scss">
.container {
  h2 {
    padding: 30px 0 15px;
    font-size: 26px;
    text-align: left;
    font-weight: bold;
  }
}
.btnContainer {
  margin-top: 20px;
}
</style>
